import { render, staticRenderFns } from "./BuildFrameButton.vue?vue&type=template&id=488021ef&scoped=true&"
import script from "./BuildFrameButton.vue?vue&type=script&lang=ts&"
export * from "./BuildFrameButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488021ef",
  null
  
)

export default component.exports